/**
 * 仿拍(copy)× 真人人物:前端当场拦(0924 车 D 一期止血,与 D-ai 错误码
 * `COPY_WITH_REAL_PERSON_UNSUPPORTED` 对齐)。
 *
 * 读码结论(方案 0921 §2.3):真人线路由只认 `role=identity` 的镜,仿拍骨架只产
 * `role=reenact` —— 选了真人人物走仿拍,身份素材一条不挂、走 ARK 直连出片:
 * **片子里没有本人,钱照扣,无任何提示**。ai 侧改为明确拒;前端在选中那一刻就说清楚
 * 并禁用提交,别让用户白编排一趟才看到拒绝。
 *
 * ★只拦 copy 档:learn 档(只学套路)走导演编排线,人物实体会产 identity 参考。
 * ★虚拟人(`characterIsRealPerson=false`)不受影响:它没有身份审核那套链路。
 */
import { COPY_WITH_REAL_PERSON_TEXT } from "./realPersonErrors";

export function copyWithRealPersonBlockReason(input: {
  hasBlueprint: boolean;
  fidelityMode: "copy" | "learn";
  characterIsRealPerson: boolean | null | undefined;
}): string | null {
  if (!input.hasBlueprint) return null;
  if (input.fidelityMode !== "copy") return null;
  if (input.characterIsRealPerson !== true) return null;
  return COPY_WITH_REAL_PERSON_TEXT;
}
